import * as Constants from '../../costants'

type StringValidationMsg = {
    content: string
}
type PowerValidationMsg = {
    cavalli: number,
    kw: number
}
type PlateValidation = {
    targa: string
}

type ValidationResponse = {
    status: number,
    msg: string,
    obj?: any
}

export function voidFunction() {}

/**
 * Valida un valore lato server
 * @param url l'url da chiamare
 * @param value il valore da validare
 */
export async function valueValidation (
    url: string,
    value: any,
    successCallback: Function,
    errorCallback: Function
): Promise<{}> {
    const isObject = typeof value === 'object'

    const msg : StringValidationMsg | PowerValidationMsg | PlateValidation = (!isObject)
        ? { content: value }
        : value;

    return fetch(
        url, 
        {
            method: "post",
            credentials: "include",
            body: JSON.stringify(msg),
            headers: {
                /** AUTH_REDACTED */
                "Content-Type": "application/json"
            },
        }
    )
    .then(response => {
        return response.json();
    })
    .then((result : ValidationResponse ) => {

        if ( result.status > 204 ) {
            return errorCallback?.(result.msg);
        }
        
        return successCallback?.(result);
    })
    .catch(err => {
        return errorCallback?.(err?.message);
    });
}

export function numberValidation (
    value: string,
    koCallBack: Function
) {
    valueValidation(
        Constants.NUMBER_VALIDATION_URL,
        value,
        voidFunction,
        koCallBack
    )
}

export function objectsNamesValidation (
    value: string,
    koCallBack: Function
) { 
    valueValidation(
        Constants.OBJECTS_NAMES_URL,
        value,
        voidFunction,
        koCallBack
    )
}

export function namesValidation (
    value: string,
    koCallBack: Function
) {

    valueValidation(
        Constants.NAMES_VALIDATION_URL,
        value,
        voidFunction,
        koCallBack
    )
}

export function carPlateValidation (
    plate: string,
    koCallBack: Function
) {

    valueValidation(
        Constants.CAR_PLATE_VALIDATION_URL,
        {targa: plate},
        voidFunction,
        koCallBack
    )
}

export function bikePlateValidation (
    plate: string,
    koCallBack: Function
) {

    valueValidation(
        Constants.BIKE_PLATE_VALIDATION_URL,
        {targa: plate},
        voidFunction,
        koCallBack
    )
}

export function cc50PlateValidation (
    plate: string,
    koCallBack: Function
) {

    valueValidation(
        Constants.MICROCAR_PLATE_VALIDATION_URL,
        {targa: plate},
        voidFunction,
        koCallBack
    )
}

export function plateByVehicleValidation (
    plate: string,
    type: number,
    koCallBack: Function
) {

    valueValidation(
        Constants.TRAGA_TIPO_VEICOLO_VALIDATION_URL,
        {targa: plate, tipologiaVeicolo: type},
        voidFunction,
        koCallBack
    )
}